import * as Yup from 'yup';
import { DateTime } from 'luxon';

import { formatPhoneNumber } from '../../utils/util';

const headers = [
  {
    label: 'Name',
    id: 'full_name'
  },

];

const mobile_headers = [
  {
    label: 'Name',
    id: 'full_name'
  },
  {
    label: 'Phone',
    id: 'mobile_phone',
    render: (row) => formatPhoneNumber(row.mobile_phone)
  },
  {
    label: "Balance",
    currency: true,
    id: "final_balance"
  }
]

const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  },
  {
    id: "balance",
    type: "balance",
    label: "Balance",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "title",
    label: "Title",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "promo_code",
    label: "Promo Code",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    multiline: true,
    rows: 2,
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Adjustment Details",
    name: "adjustment_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "toggle",
    name: "adjustment_type",
    label: "Adjustment Type",
    options: [{value: "discount", label: "Discount"}, {value: "surcharge", label: "Surcharge"}],
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "expires",
    label: "Expires",
    type: "checkbox",
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "start_date",
    label: "Start Date",
    type: "date",
    checkDisplayField: (values) => { return !!values?.expires},
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "end_date",
    label: "End Date",
    type: "date",
    checkDisplayField: (values) => { return !!values?.expires},
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "use_by_default",
    label: "Use By Default",
    type: "checkbox",
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Rate Details",
    name: "rate_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "toggle",
    name: "rate_type",
    label: "Rate Type",
    options: [{value: "percentage", label: "Percentage"}, {value: "dollar", label: "Dollar"}],
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "number",
    name: "rate",
    label: "Rate",
    type: "number",
    size: {xs: 12},
  },
  {
    fieldType: "divider",
    header: "Advanced Options",
    name: "advanced",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "toggle",
    name: "adjustment_level",
    label: "Adjustment Level",
    options: [{value: "invoice", label: "General"}, {value: "item", label: "Vendor"}],
    size: {xs: 12},
  },
  {
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "brand_name",
    label: "Select Wig Brand",
    url: "vendors",
    fieldName: "brand_name",
    displayField: "brand_name",
    checkDisplayField: (values) => { return values?.adjustment_level === "item"},
    size: {xs: 12, lg: 12},
  }
 
  
]

const initialValues = {
  title: "",
  promo_code: "",
  description: "",
  adjustment_type: "discount",
  expires: false,
  start_date: DateTime.local().startOf('day'),
  end_date: DateTime.local().startOf('day'),
  rate_type: "percentage",
  rate: "",
  use_by_default: false,
  adjustment_level: "invoice",
  brand_name: "",
}

const schema = Yup.object().shape({

});

export { mobile_headers, headers, filters, fields, schema, initialValues };